import { render } from "./viewblague.vue?vue&type=template&id=20e45865"
import script from "./viewblague.vue?vue&type=script&lang=js"
export * from "./viewblague.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__